export interface EditableEntity {
  canAdd: boolean;
  canEdit: boolean;
  canDelete: boolean;
}

export interface Modifiable {
  canEdit: boolean;
  isReadOnly: boolean;
}

export class ModifiableEntity implements Modifiable {
  canEdit: boolean;
  get isReadOnly(): boolean {
    return !this.canEdit;
  }
  set isReadOnly(value: boolean) {
    this.canEdit = !value;
  }

  constructor() {
    this.canEdit = true;
  }

  public loadFromJson(data) {
    this.canEdit = typeof data.canEdit !== 'undefined' ? data.canEdit : true;
  }
}
